import Typography from "../../../../../../components/typography/Typography";
import YaraMatchesMoreRulesTooltip from "./YaraMatchesMoreRulesTooltip";
import { YaraRuleMatch } from "../../../../@types";

type YaraMatchesMatchedRulesProps = {
  rules: Array<YaraRuleMatch>;
  threshold?: number;
};

const YaraMatchesMatchedRules = ({
  rules,
  threshold = 50
}: YaraMatchesMatchedRulesProps) => {
  const ruleNames = rules.map(rule => rule.name);

  if (ruleNames.length === 0) {
    return null;
  }

  const rulesThatFit: string[] = [];
  const rulesToPutInTooltip: string[] = [];
  let currentRulesLength = 0;
  ruleNames.forEach(ruleName => {
    if (currentRulesLength + ruleName.length > threshold) {
      rulesToPutInTooltip.push(ruleName);
      return;
    }
    currentRulesLength += ruleName.length;
    rulesThatFit.push(ruleName);
  });

  if (rulesThatFit.length === 0 && ruleNames.length > 0) {
    return (
      <div className={"flex"}>
        <Typography variant={"body1"} title={ruleNames[0]}>
          {ruleNames[0].slice(0, threshold - 3)}...
        </Typography>
        <YaraMatchesMoreRulesTooltip rules={ruleNames.slice(1)} />
      </div>
    );
  }

  return (
    <div className={"flex flex-gap-1"}>
      <Typography variant={"body1"}>{rulesThatFit.join(", ")}</Typography>
      <YaraMatchesMoreRulesTooltip rules={rulesToPutInTooltip} />
    </div>
  );
};

export default YaraMatchesMatchedRules;
